<template>
  <div>
    <div class="sub-link" v-if="model.display_type == 'link'">
      <router-link
        v-if="model.reference.indexOf('/view-app/') > -1"
        @click="actionClick(model)"
        :to="model.reference"
        :title="model.help_text | trim"
      >{{model.title  | truncate(textTrimLength)}} </router-link>
      <a
        v-else
        @click="actionClick(model)"
        :href="model.reference"
        :title="model.help_text | trim"
        :ref="model.action"
        :target="model.action"
      >{{model.title  | truncate(textTrimLength)}}</a>
    </div>
    <div class="sub-link"  v-if="model.display_type == CONSTANTS.ROOT_LINK_TYPES.AZURE_ACCESS_LINK">
      <button
        class="btn-link"
        @click="showAccessRequestModal(model)"
        :title="model.help_text | trim"
      >{{model.title}}</button>
    </div>
    <div class="dropdown" v-if="model.display_type == 'list'">
      <button
        class="dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :title="model.help_text | trim"
      >{{model.title  | truncate(textTrimLength)}}</button>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
        <div v-for="item in model.items" :key="item.title+item.url">
          <router-link
            v-if="item.url.indexOf('/view-app/') > -1"
            @click="actionItemClick(item)"
            :to="item.url"
            :title="item.help_text | trim"
            class="dropdown-item"
          >{{item.title}}</router-link>
          <a
            v-else
            @click="actionItemClick(item)"
            :href="item.url"
            :title="item.help_text | trim"
            :ref="item.action"
            :target="item.action"
            class="dropdown-item"
          >{{item.title}}</a>
        </div>
      </div>
    </div>
    <access-request-modal
      v-if="displayAccessRequestModal"
      :model="app"
      :linkData="model"
      @close="closeAccessRequestModal"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import util from "@/util";
import AppHandlerMixin from "@/mixins/AppHandlerMixin";

export default {
  name: "TileLink",
  mixins: [AppHandlerMixin],
  props: {
    app: Object,
    model: Object,
    fullWidth: Boolean
  },
  data: function() {
    return {
      textTrimLength: this.fullWidth ? 60 : 18
    };
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  mounted() {
    if (!this.fullWidth) {
      this.handleResize()
      window.addEventListener('resize', this.handleResize)
    }
    
    if (this.model && this.model.display_type === "list" && this.model.items) {
      this.model.items.sort(util.orderSortComparator);
    }
    
    if (util.stringIsBlank(this.model.help_text)) {
      this.model.help_text = this.model.title
    }
  },
  methods: {
    handleResize() {
      if (window.innerWidth < 992) {
        this.textTrimLength = 60
      } else {
        this.textTrimLength = 18;
      }
    },
    actionClick(model) {
      let ref = {}
      ref.action = model.action
      ref.link = model.reference

      this.trackEvent(`app_id=${this.app.id} title=${this.app.title} ref=${model.reference} type=sub-link`);      
      util.postActionClick(this.app, this.getUser.userName, this.$router.currentRoute.path, ref, "sub-link");
    },
    actionItemClick(item) {
      let ref = {}
      ref.action = item.action
      ref.link = item.url

      this.trackEvent(`app_id=${this.app.id} title=${this.app.title} ref=${item.url} type=sub-link`);
      util.postActionClick(this.app, this.getUser.userName, this.$router.currentRoute.path, ref, "sub-link");      
    }
  }
};
</script>

<style scoped>
a {
  font-size: 12px;
  color: #0696d7;
}
.sub-link{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sub-link a {
  font-size: 13px;
  font-weight: bold;
  color: var(--secondary-color);
  border: none;
  background: #fff;
  text-decoration: none;
  white-space: nowrap;
}
.sub-link .btn-link {
  font-size: 13px;
  font-weight: bold;
  color: var(--secondary-color);
  border: none;
  background: #fff;
  text-decoration: none;
  white-space: nowrap;
}
.sub-link a:hover{
  font-weight: bolder;
  color: #6a6aff;
}
button {
  background-color: #fff;
  border: none;
  font-size: 10px;
  color: #0696d7;
  cursor: pointer;
  max-height: 20px;
  overflow: hidden;
}
.dropdown-menu {
  border-radius: 0;
}

@media (max-width: 991px) {
  button {
    margin-left: 0px;
  }
}
</style>
